// extracted by mini-css-extract-plugin
export var textBlock = "MentionsLegales-module--textBlock--ebSKC";
export var wrapper = "MentionsLegales-module--wrapper---YqI0";